import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { Done } from '@material-ui/icons'
import cx from 'clsx'
import { useEffect, useState } from 'react'

import { uniqueKey } from '../../utils'

import { buildAnswerHref } from './buildAnswerLink'
import { getOperatorEscalationUrlForAction } from './getOperatorEscalationUrl'
import { AnswerActionProps } from './interface'

export function AnswerActions({
  className,
  cardId,
  pathPrefix,
  actions,
  selectionPath,
  operatorEscalationKeyword,
  onActionSelected,
  karakuriWebRootUrl,
  session,
}: AnswerActionProps) {
  const [operatorEscalationUrl, setOperatorEscalationUrl] = useState<string>('')

  useEffect(() => {
    actions?.actions?.forEach(action => {
      if (
        action &&
        !action.invalid &&
        (action.label?.includes(operatorEscalationKeyword) || action.isOperatorConnect)
      ) {
        const generatedUrl = getOperatorEscalationUrlForAction({
          action,
          karakuriWebRootUrl,
          operatorEscalationKeyword,
          session,
        })
        setOperatorEscalationUrl(generatedUrl)
      }
    })
  }, [actions, karakuriWebRootUrl, operatorEscalationKeyword, session])

  return actions && actions.actions ? (
    <div className="faq-answer-actions-wrapper">
      {actions.actions.map((action, index) => {
        if (!action || action.invalid) {
          return null
        }

        const id = action.id || ''
        if (action.label?.includes(operatorEscalationKeyword) || action.isOperatorConnect) {
          return (
            <Button
              key={uniqueKey('button', cardId, id, action.id || '', index)}
              fullWidth
              variant="contained"
              color="secondary"
              className={cx('faq-button', 'faq-button-operator', className)}
              href={operatorEscalationUrl}
              target="chat"
              rel="noopener noreferrer"
            >
              {action.label}
            </Button>
          )
        }

        if (action.uri) {
          return (
            <Button
              key={uniqueKey('button', cardId, id, action.id || '', index)}
              fullWidth
              variant="contained"
              color="secondary"
              className={cx('faq-button', 'faq-button-uri', className)}
              href={action.uri}
              target="_blank"
              rel="noopener"
            >
              {action.label}
            </Button>
          )
        }

        if (action.external) {
          return (
            <Button
              key={uniqueKey('button', cardId, id, action.id || '', index)}
              fullWidth
              variant="contained"
              color="secondary"
              className={cx(['faq-button', 'faq-button-external', className])}
              href={id ? buildAnswerHref(id, pathPrefix) : undefined}
              onClick={e => onActionSelected(e, action.id, !!action.external, action.uri)}
            >
              <Typography color="inherit" variant="inherit">
                {action.label}
              </Typography>
            </Button>
          )
        }

        const selected = selectionPath.includes(id)
        const unselected =
          !selected && (actions?.actions || []).some(x => x && selectionPath.includes(x.id))
        return (
          <Button
            key={uniqueKey('button', cardId, id, action.id || '', index)}
            fullWidth
            variant="contained"
            color="secondary"
            className={cx(
              'faq-button',
              'faq-button-answer',
              {
                'faq-button-unselected': unselected,
                'faq-button-selected': selected,
              },
              className
            )}
            onClick={e => onActionSelected(e, action.id, !!action.external, action.uri)}
          >
            <Typography color={unselected ? 'textSecondary' : 'inherit'} variant="inherit">
              {action.label}
              {selected ? <Done fontSize="small" className="faq-button-selected-icon" /> : null}
            </Typography>
          </Button>
        )
      })}
    </div>
  ) : null
}
